import React from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const PaySuccess = () => {
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div class="modal-content">
            <div class="checkmark-circle">
              <FontAwesomeIcon icon={faCheck} />
              <div class="checkmark"></div>
            </div>
            <p>The system is reviewing the order, please wait patiently</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
